import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  static values = {
    url: String
  }

  async toggle (event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.pending) return
    this.pending = true

    const wasLiked = this.element.classList.contains('is-liked')
    const countEl = this.element.querySelector('.feed-rail-count')
    const previousCount = countEl ? Number.parseInt(countEl.textContent, 10) || 0 : 0

    this.applyLikeState(!wasLiked, wasLiked ? previousCount - 1 : previousCount + 1)

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': this.csrfToken,
          Accept: 'text/vnd.turbo-stream.html'
        },
        credentials: 'same-origin'
      })

      if (response.redirected && response.url.includes('/users/sign_in')) {
        this.applyLikeState(wasLiked, previousCount)
        window.location.assign(response.url)
        return
      }

      if (!response.ok) {
        this.applyLikeState(wasLiked, previousCount)
        return
      }

      const body = await response.text()
      if (body.includes('<turbo-stream')) {
        Turbo.renderStreamMessage(body)
      }
    } catch (_error) {
      this.applyLikeState(wasLiked, previousCount)
    } finally {
      this.pending = false
    }
  }

  applyLikeState (liked, count) {
    this.element.classList.toggle('is-liked', liked)
    this.element.setAttribute('aria-pressed', liked ? 'true' : 'false')
    this.element.setAttribute('aria-label', liked ? 'Unlike video' : 'Like video')

    const countEl = this.element.querySelector('.feed-rail-count')
    if (countEl) countEl.textContent = String(Math.max(0, count))

    const icon = this.element.querySelector('.feed-like-icon svg')
    if (icon) icon.setAttribute('fill', liked ? 'currentColor' : 'none')
  }

  get csrfToken () {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
